export const SET_ACTIVE_TEMPLATE_ACTION = "SET_ACTIVE_TEMPLATE_ACTION";
export const FETCH_TEMPLATES_BEGIN_ACTION = "FETCH_TEMPLATES_BEGIN_ACTION";
export const FETCH_TEMPLATES_FAILURE_ACTION = "FETCH_TEMPLATES_FAILURE_ACTION";
export const FETCH_TEMPLATES_SUCCESS_ACTION = "FETCH_TEMPLATES_SUCCESS_ACTION";
export const DELETE_TEMPLATE_FOLDER_BEGIN_ACTION = "DELETE_TEMPLATE_FOLDER_BEGIN_ACTION";
export const DELETE_TEMPLATE_FOLDER_SUCCESS_ACTION = "DELETE_TEMPLATE_FOLDER_SUCCESS_ACTION";
export const DELETE_TEMPLATE_FOLDER_FAILURE_ACTION = "DELETE_TEMPLATE_FOLDER_FAILURE_ACTION";
export const REORDER_TEMPLATE_PARAMETERS_ACTION = "REORDER_PARAMETER_ACTION";
export const SET_SELECTED_PARAMETER_ACTION = "SET_SELECTED_PARAMETER_ACTION";
export const SET_SELECTED_GROUP_ACTION = "SET_SELECTED_GROUP_ACTION";
export const CREATE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION =
  "CREATE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION";
export const CREATE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION =
  "CREATE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION";
export const CREATE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION =
  "CREATE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION";  
export const DELETE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION =
  "DELETE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION";
export const DELETE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION =
  "DELETE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION";

export const UPDATE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION =
  "UPDATE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION";
export const UPDATE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION =
  "UPDATE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION";
export const UPDATE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION =
  "UPDATE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION";
export const CREATE_TEMPLATE_FOLDER_BEGIN_ACTION =
  "CREATE_TEMPLATE_FOLDER_BEGIN_ACTION";
export const CREATE_TEMPLATE_FOLDER_SUCCESS_ACTION =
  "CREATE_TEMPLATE_FOLDER_SUCCESS_ACTION";
export const UPDATE_TEMPLATE_FOLDER_BEGIN_ACTION =
  "UPDATE_TEMPLATE_FOLDER_BEGIN_ACTION";
export const UPDATE_TEMPLATE_FOLDER_SUCCESS_ACTION =
  "UPDATE_TEMPLATE_FOLDER_SUCCESS_ACTION";  
export const TOGGLE_TEMPLATE_FOLDER_ACTION = "TOGGLE_TEMPLATE_FOLDER_ACTION";
export const UPDATE_FOLDERS_NODE_ACTION = "UPDATE_FOLDERS_NODE_ACTION";
export const UPDATE_FOLDER_ITEM_BEGIN_ACTION =
  "UPDATE_FOLDER_ITEM_BEGIN_ACTION";
export const RENAME_FOLDER_ITEM_ACTION = "RENAME_FOLDER_ITEM_ACTION";
export const UPDATE_FOLDER_ITEM_SUCCESS_ACTION =
  "UPDATE_FOLDER_ITEM_SUCCESS_ACTION";
export const UPDATE_FOLDER_ITEM_FAILURE_ACTION =
  "UPDATE_FOLDER_ITEM_FAILURE_ACTION";
export const DELETE_TEMPLATE_PARAMETER_ACTION =
  "DELETE_TEMPLATE_PARAMETER_ACTION";
export const FETCH_TEMPLATE_BEGIN_ACTION = "FETCH_TEMPLATE_BEGIN_ACTION";
export const FETCH_TEMPLATE_SUCCESS_ACTION = "FETCH_TEMPLATE_SUCCESS_ACTION";
export const FETCH_TEMPLATE_FAILURE_ACTION = "FETCH_TEMPLATE_FAILURE_ACTION";
export const UPDATE_ACTIVE_TEMPLATE_PROPERTIES_ACTION =
  "UPDATE_ACTIVE_TEMPLATE_PROPERTIES_ACTION";
export const UPDATE_TEMPLATE_BEGIN_ACTION = "UPDATE_TEMPLATE_BEGIN_ACTION";
export const UPDATE_TEMPLATE_SUCCESS_ACTION = "UPDATE_TEMPLATE_SUCCESS_ACTION";
export const UPDATE_TEMPLATE_FAILURE_ACTION = "UPDATE_TEMPLATE_FAILURE_ACTION";
export const CREATE_NEW_TEMPLATE_BEGIN_ACTION =
  "CREATE_NEW_TEMPLATE_BEGIN_ACTION";
export const CREATE_NEW_TEMPLATE_SUCCESS_ACTION =
  "CREATE_NEW_TEMPLATE_SUCCESS_ACTION";
export const CREATE_NEW_TEMPLATE_FAILURE_ACTION =
  "CREATE_NEW_TEMPLATE_FAILURE_ACTION";
export const CREATE_PARAMETER_GROUP_BEGIN_ACTION =
  "CREATE_PARAMETER_GROUP_BEGIN_ACTION";
export const CREATE_PARAMETER_GROUP_SUCCESS_ACTION =
  "CREATE_PARAMETER_GROUP_SUCCESS_ACTION";
export const CREATE_PARAMETER_GROUP_FAILURE_ACTION =
  "CREATE_PARAMETER_GROUP_FAILURE_ACTION";

export const SET_SELECTED_FOLDER_ACTION = "SET_SELECTED_FOLDER_ACTION";
export const UPDATE_SELECTED_GROUP_ACTION = "UPDATE_SELECTED_GROUP_ACTION";
export const CLONE_TEMPLATE_BEGIN_ACTION = "CLONE_TEMPLATE_BEGIN_ACTION";
export const CLONE_TEMPLATE_SUCCESS_ACTION = "CLONE_TEMPLATE_SUCCESS_ACTION";
export const CLONE_TEMPLATE_FAILURE_ACTION = "CLONE_TEMPLATE_FAILURE_ACTION";
export const DELETE_PARAMETERS_GROUP_BEGIN_ACTION =
  "DELETE_PARAMETERS_GROUP_BEGIN_ACTION";
export const DELETE_PARAMETERS_GROUP_SUCCESS_ACTION =
  "DELETE_PARAMETERS_GROUP_SUCCESS_ACTION";
export const DELETE_PARAMETERS_GROUP_FAILURE_ACTION = "DELETE_PARAMETERS_GROUP_FAILURE_ACTION";

export const UPDATE_TEMPLATE_THUMBNAIL_IMAGE = 'UPDATE_TEMPLATE_THUMBNAIL_IMAGE';
export const UPDATE_TEMPLATE_MODELER_THUMBNAIL_IMAGE = 'UPDATE_TEMPLATE_MODELER_THUMBNAIL_IMAGE';
export const PUBLISH_TEMPLATE_BEGIN_ACTION = 'PUBLISH_TEMPLATE_BEGIN_ACTION';
export const PUBLISH_TEMPLATE_SUCCESS_ACTION = 'PUBLISH_TEMPLATE_SUCCESS_ACTION';
export const PUBLISH_TEMPLATE_FAILURE_ACTION = 'PUBLISH_TEMPLATE_FAILURE_ACTION';
export const UNPUBLISH_TEMPLATE_BEGIN_ACTION = 'UNPUBLISH_TEMPLATE_BEGIN_ACTION';
export const UNPUBLISH_TEMPLATE_SUCCESS_ACTION = 'UNPUBLISH_TEMPLATE_SUCCESS_ACTION';
export const UNPUBLISH_TEMPLATE_FAILURE_ACTION = 'UNPUBLISH_TEMPLATE_FAILURE_ACTION';
export const DELETE_TEMPLATE_BEGIN_ACTION = 'DELETE_TEMPLATE_BEGIN_ACTION';
export const DELETE_TEMPLATE_SUCCESS_ACTION = 'DELETE_TEMPLATE_SUCCESS_ACTION';
export const DELETE_TEMPLATE_FAILURE_ACTION = 'DELETE_TEMPLATE_FAILURE_ACTION';
export const UPDATE_TEMPLATE_PARAMATER_GROUP_BEGIN_ACTION = 'UPDATE_PARAMATER_GROUP_BEGIN_ACTION';
export const UPDATE_TEMPLATE_PARAMATER_GROUP_SUCCESS_ACTION = 'UPDATE_TEMPLATE_PARAMATER_GROUP_SUCCESS_ACTION';
export const UPDATE_TEMPLATE_PARAMATER_GROUP_FAILURE_ACTION = 'UPDATE_TEMPLATE_PARAMATER_GROUP_FAILURE_ACTION';
export const DELETE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION = 'DELETE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION';
export const DELETE_TEMPLATE_PARAMETER_GROUP_FAILURE_ACTION = 'DELETE_TEMPLATE_PARAMETER_GROUP_FAILURE_ACTION';
export const RESET_ACTIVE_TEMPLATE_ACTION = 'RESET_ACTIVE_TEMPLATE_ACTION';
export const FETCH_FILE_CONTENT_BEGIN_ACTION = 'FETCH_FILE_CONTENT_BEGIN_ACTION';
export const FETCH_FILE_CONTENT_SUCCESS_ACTION = 'FETCH_FILE_CONTENT_SUCCESS_ACTION';
export const FETCH_FILE_CONTENT_FAILURE_ACTION = 'FETCH_FILE_CONTENT_FAILURE_ACTION';
export const UPDATE_FILE_CONTENT_BEGIN_ACTION = 'UPDATE_FILE_CONTENT_BEGIN_ACTION';
export const UPDATE_FILE_CONTENT_SUCCESS_ACTION = 'UPDATE_FILE_CONTENT_SUCCESS_ACTION';
export const UPDATE_FILE_CONTENT_FAILURE_ACTION = 'UPDATE_FILE_CONTENT_FAILURE_ACTION';
export const ADD_OBJECT_FILE_UPLOAD_CANCEL_TOKEN_ACTION = 'ADD_OBJECT_FILE_UPLOAD_CANCEL_TOKEN_ACTION';
export const REMOVE_OBJECT_FILE_UPLOAD_CANCEL_TOKEN_ACTION = 'REMOVE_OBJECT_FILE_UPLOAD_CANCEL_TOKEN_ACTION';
export const SET_OBEJCT_FILE_UPLOAD_PROGRESS_ACTION = 'SET_OBEJCT_FILE_UPLOAD_PROGRESS_ACTION';
export const PUBLISH_PRODUCT_BEGIN_ACTION = 'PUBLISH_PRODUCT_BEGIN_ACTION';
export const PUBLISH_PRODUCT_SUCCESS_ACTION = 'PUBLISH_PRODUCT_SUCCESS_ACTION';
export const PUBLISH_PRODUCT_FAILURE_ACTION = 'PUBLISH_PRODUCT_FAILURE_ACTION';
export const FETCH_PRODUCTS_BEGIN_ACTION = 'FETCH_PRODUCTS_BEGIN_ACTION';
export const FETCH_PRODUCTS_SUCCESS_ACTION = 'FETCH_PRODUCTS_SUCCESS_ACTION';
export const FETCH_PRODUCTS_FAILURE_ACTION = 'FETCH_PRODUCTS_FAILURE_ACTION';
export const UNPUBLISH_PRODUCT_BEGIN_ACTION = 'UNPUBLISH_PRODUCT_BEGIN_ACTION';
export const UNPUBLISH_PRODUCT_SUCCESS_ACTION = 'UNPUBLISH_PRODUCT_SUCCESS_ACTION';
export const UNPUBLISH_PRODUCT_FAILURE_ACTION = 'UNPUBLISH_PRODUCT_FAILURE_ACTION';


export const unpublishProductBegin = (templateId) => {
  return {
    type: UNPUBLISH_PRODUCT_BEGIN_ACTION,
    payload: templateId,
  };
};

export const unpublishProductSuccess = (published) => {
  return {
    type: UNPUBLISH_PRODUCT_SUCCESS_ACTION,
    payload: published,
  };
};

export const unpublishProductFailure = (message) => {
  return {
    type: UNPUBLISH_PRODUCT_FAILURE_ACTION,
    payload: message,
  };
};


export const fetchProductsBegin = () => {
  return {
    type: FETCH_PRODUCTS_BEGIN_ACTION,
    payload: undefined,
  };
};

export const fetchProductsSuccess = (res) => {
  return {
    type: FETCH_PRODUCTS_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchProductsFailure = (message) => {
  return {
    type: FETCH_PRODUCTS_FAILURE_ACTION,
    payload: message,
  };
};



export const publishProductBegin = (templateId) => {
  return {
    type: PUBLISH_PRODUCT_BEGIN_ACTION,
    payload: templateId,
  };
};

export const publishProductSuccess = (published) => {
  return {
    type: PUBLISH_PRODUCT_SUCCESS_ACTION,
    payload: published,
  };
};

export const publishProductFailure = (message) => {
  return {
    type: PUBLISH_PRODUCT_FAILURE_ACTION,
    payload: message,
  };
};





export const resetActiveTemplate = () => {
  return {
    type: RESET_ACTIVE_TEMPLATE_ACTION,
    payload: undefined,
  };
};
export const addObjectFileUploadCancelToken = (filename, cancelToken) => {
  return {
    type: ADD_OBJECT_FILE_UPLOAD_CANCEL_TOKEN_ACTION,
    filename,
    cancelToken
  };
};

export const removeObjectFileUploadCancelToken = (filename) => {
  return {
    type: REMOVE_OBJECT_FILE_UPLOAD_CANCEL_TOKEN_ACTION,
    filename
  };
};

export const setObjectFileUploadProgress = (filename, progress) => {
  return {
    type: SET_OBEJCT_FILE_UPLOAD_PROGRESS_ACTION,
    payload: { filename, progress }
  };
};

export const cloneTemplateBegin = (template) => {
  return {
    type: CLONE_TEMPLATE_BEGIN_ACTION,
    payload: template,
  };
};
export const cloneTemplateSuccess = (template) => {
  return {
    type: CLONE_TEMPLATE_SUCCESS_ACTION,
    payload: template,
  };
};

export const cloneTemplateFailure = (message) => {
  return {
    type: CLONE_TEMPLATE_FAILURE_ACTION,
    payload: message,
  };
};

export const updateSelectedGroup = (payload) => {
  return {
    type: UPDATE_SELECTED_GROUP_ACTION,
    payload: { ...payload },
  };
};
// export const updateSelectedParameter = (newParameter) => {
//   return {
//     type: UPDATE_SELECTED_PARAMETER_ACTION,
//     payload: { ...newParameter },
//   };
// };
export const createParameterGroupBegin = () => {
  return {
    type: CREATE_PARAMETER_GROUP_BEGIN_ACTION,
    payload: undefined,
  };
};
export const createParameterGroupSuccess = (payload) => {
  return {
    type: CREATE_PARAMETER_GROUP_SUCCESS_ACTION,
    payload: { ...payload },
  };
};

export const createParameterGroupFailure = (message) => {
  return {
    type: CREATE_PARAMETER_GROUP_FAILURE_ACTION,
    payload: message,
  };
};
export const publishTemplateBegin = (templateId) => {
  return {
    type: PUBLISH_TEMPLATE_BEGIN_ACTION,
    payload: templateId,
  };
};

export const publishTemplateSuccess = (published) => {
  return {
    type: PUBLISH_TEMPLATE_SUCCESS_ACTION,
    payload: published,
  };
};

export const publishTemplateFailure = (message) => {
  return {
    type: PUBLISH_TEMPLATE_FAILURE_ACTION,
    payload: message,
  };
};

export const unpublishTemplateBegin = (templateId) => {
  return {
    type: UNPUBLISH_TEMPLATE_BEGIN_ACTION,
    payload: templateId,
  };
};

export const unpublishTemplateSuccess = (published) => {
  return {
    type: UNPUBLISH_TEMPLATE_SUCCESS_ACTION,
    payload: published,
  };
};

export const unpublishTemplateFailure = (message) => {
  return {
    type: UNPUBLISH_TEMPLATE_FAILURE_ACTION,
    payload: message,
  };
};

export const deleteTemplateBegin = (templateId) => {
  return {
    type: DELETE_TEMPLATE_BEGIN_ACTION,
    payload: templateId,
  };
};

export const deleteTemplateSuccess = (templateId) => {
  return {
    type: DELETE_TEMPLATE_SUCCESS_ACTION,
    payload: templateId,
  };
};

export const deleteTemplateFailure = (message) => {
  return {
    type: DELETE_TEMPLATE_FAILURE_ACTION,
    payload: message,
  };
};

export const deleteTemplateFolderBegin = (payload) => {
  return {
    type: DELETE_TEMPLATE_FOLDER_BEGIN_ACTION,
    payload: { ...payload },
  };
};

export const deleteTemplateFolderSuccess = (payload) => {
  return {
    type: DELETE_TEMPLATE_FOLDER_SUCCESS_ACTION,
    payload: { ...payload },
  };
};

export const deleteTemplateFolderFailure = (message) => {
  return {
    type: DELETE_TEMPLATE_FOLDER_FAILURE_ACTION,
    payload: message,
  };
};

export const deleteParametersGroupBegin = (payload) => {
  return {
    type: DELETE_PARAMETERS_GROUP_BEGIN_ACTION,
    payload: { ...payload },
  };
};

export const deleteParametersGroupSuccess = (payload) => {
  return {
    type: DELETE_PARAMETERS_GROUP_SUCCESS_ACTION,
    payload: { ...payload },
  };
};

export const deleteTemplateParameterItemBegin = (payload) => {
  return {
    type: DELETE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION,
    payload: { ...payload },
  };
};

export const deleteTemplateParameterItemSuccess = (payload) => {
  return {
    type: DELETE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION,
    payload: { ...payload },
  };
};

export const deleteTemplateParameterItemFailure = (message) => {
  return {
    type: DELETE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION,
    payload: message,
  };
};

export const updateTemplateParameterItemBegin = (payload) => {
  return {
    type: UPDATE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION,
    payload: { ...payload },
  };
};

export const updateTemplateParameterItemSuccess = (payload) => {
  return {
    type: UPDATE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION,
    payload: { ...payload },
  };
};
export const updateTemplateParameterItemFailure = (message) => {
  return {
    type: UPDATE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION,
    payload: message,
  };
};
export const deleteParametersGroupFailure = (message) => {
  return {
    type: DELETE_PARAMETERS_GROUP_FAILURE_ACTION,
    payload: message,
  };
};
export const setSelectedParameter = (payload) => {
  return {
    type: SET_SELECTED_PARAMETER_ACTION,
    payload: { ...payload },
  };
};
export const setSelectedFolder = (payload) => {
  return {
    type: SET_SELECTED_FOLDER_ACTION,
    payload: { ...payload },
  };
};
export const setSelectedGroup = (payload) => {
  return {
    type: SET_SELECTED_GROUP_ACTION,
    payload: { ...payload },
  };
};

export const reorderTemplateParameters = (payload) => {
  return {
    type: REORDER_TEMPLATE_PARAMETERS_ACTION,
    payload: { ...payload },
  };
};

export const createTemplateParameterItemBegin = (payload) => {
  return {
    type: CREATE_TEMPLATE_PARAMETER_ITEM_BEGIN_ACTION,
    payload: { ...payload },
  };
};

export const createTemplateParameterItemSuccess = (payload) => {
  return {
    type: CREATE_TEMPLATE_PARAMETER_ITEM_SUCCESS_ACTION,
    payload: { ...payload },
  };
};
export const createTemplateParameterItemFailure = (message) => {
  return {
    type: CREATE_TEMPLATE_PARAMETER_ITEM_FAILURE_ACTION,
    payload: message,
  };
};
export const createTemplateFolderBegin = (payload) => {
  return {
    type: CREATE_TEMPLATE_FOLDER_BEGIN_ACTION,
    payload: { ...payload },
  };
};
export const createTemplateFolderSuccess = (payload) => {
  return {
    type: CREATE_TEMPLATE_FOLDER_SUCCESS_ACTION,
    payload: { ...payload },
  };
};

export const updateTemplateFolderBegin = (payload) => {
  return {
    type: UPDATE_TEMPLATE_FOLDER_BEGIN_ACTION,
    payload: { ...payload },
  };
};

export const updateTemplateFolderSuccess = (payload) => {
  return {
    type: UPDATE_TEMPLATE_FOLDER_SUCCESS_ACTION,
    payload: { ...payload },
  };
};



export const toggleTemplateFolder = (payload) => {
  return {
    type: TOGGLE_TEMPLATE_FOLDER_ACTION,
    payload: { ...payload },
  };
};

export const updateFoldersNode = (payload) => {
  return {
    type: UPDATE_FOLDERS_NODE_ACTION,
    payload: { ...payload },
  };
};
export const updateFolderItemBegin = (payload) => {
  return {
    type: UPDATE_FOLDER_ITEM_BEGIN_ACTION,
    payload: { ...payload },
  };
};
export const updateFolderItemSuccess = (payload) => {
  return {
    type: UPDATE_FOLDER_ITEM_SUCCESS_ACTION,
    payload: { ...payload },
  };
};
export const updateFolderItemFailure = (payload) => {
  return {
    type: UPDATE_FOLDER_ITEM_FAILURE_ACTION,
    payload: { ...payload },
  };
};
export const renameFolderItem = (payload) => {
  return {
    type: RENAME_FOLDER_ITEM_ACTION,
    payload: { ...payload },
  };
};
export const setActiveTemplate = (id) => {
  return {
    type: SET_ACTIVE_TEMPLATE_ACTION,
    payload: id,
  };
};

export const fetchTemplatesBegin = () => {
  return {
    type: FETCH_TEMPLATES_BEGIN_ACTION,
    payload: undefined,
  };
};
export const fetchTemplatesSuccess = (res) => {
  return {
    type: FETCH_TEMPLATES_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchTemplatesFailure = (message) => {
  return {
    type: FETCH_TEMPLATES_FAILURE_ACTION,
    payload: message,
  };
};

export const fetchActiveTemplateBegin = () => {
  return {
    type: FETCH_TEMPLATE_BEGIN_ACTION,
    payload: undefined,
  };
};
export const fetchActiveTemplateSuccess = (res) => {
  return {
    type: FETCH_TEMPLATE_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchActiveTemplateFailure = (message) => {
  return {
    type: FETCH_TEMPLATE_FAILURE_ACTION,
    payload: message,
  };
};

export const updateTemplateBegin = () => {
  return {
    type: UPDATE_TEMPLATE_BEGIN_ACTION,
    payload: undefined,
  };
};
export const updateTemplateSuccess = (res) => {
  return {
    type: UPDATE_TEMPLATE_SUCCESS_ACTION,
    payload: res,
  };
};

export const updateTemplateFailure = (message) => {
  return {
    type: UPDATE_TEMPLATE_FAILURE_ACTION,
    payload: message,
  };
};
export const updateActiveTemplateProperties = (template) => {
  return {
    type: UPDATE_ACTIVE_TEMPLATE_PROPERTIES_ACTION,
    payload: template,
  };
};

export const createNewTemplateBegin = () => {
  return {
    type: CREATE_NEW_TEMPLATE_BEGIN_ACTION,
    payload: undefined,
  };
};
export const createNewTemplateSuccess = (res) => {
  return {
    type: CREATE_NEW_TEMPLATE_SUCCESS_ACTION,
    payload: res,
  };
};

export const createNewTemplateFailure = (message) => {
  return {
    type: CREATE_NEW_TEMPLATE_FAILURE_ACTION,
    payload: message,
  };
};

export function updateTemplateThumbnailImage(imageUrl) {
  return {
    type: UPDATE_TEMPLATE_THUMBNAIL_IMAGE,
    payload: imageUrl,
  };
}

export function updateTemplateModelerThumbnailImage(imageUrl) {
  return {
    type: UPDATE_TEMPLATE_MODELER_THUMBNAIL_IMAGE,
    payload: imageUrl,
  };
}

export const updateTemplateParameterGroupBegin = () => {
  return {
    type: UPDATE_TEMPLATE_PARAMATER_GROUP_BEGIN_ACTION,
    payload: undefined,
  };
};

export const updateTemplateParameterGroupSuccess = (res) => {
  return {
    type: UPDATE_TEMPLATE_PARAMATER_GROUP_SUCCESS_ACTION,
    payload: res,
  };
};

export const updateTemplateParameterGroupFailure = (message) => {
  return {
    type: UPDATE_TEMPLATE_PARAMATER_GROUP_FAILURE_ACTION,
    payload: message,
  };
};

export const fetchFileContentBegin = () => {
  return {
    type: FETCH_FILE_CONTENT_BEGIN_ACTION,
    payload: undefined,
  };
};

export const fetchFileContentSuccess = (res) => {
  return {
    type: FETCH_FILE_CONTENT_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchFileContentFailure = (message) => {
  return {
    type: FETCH_FILE_CONTENT_FAILURE_ACTION,
    payload: message,
  };
};

export const updateFileContentBegin = () => {
  return {
    type: UPDATE_FILE_CONTENT_BEGIN_ACTION,
    payload: undefined,
  };
}

export const updateFileContentSuccess = (res) => {
  return {
    type: UPDATE_FILE_CONTENT_SUCCESS_ACTION,
    payload: res,
  };
}

export const updateFileContentFailure = (message) => {
  return {
    type: UPDATE_FILE_CONTENT_FAILURE_ACTION,
    payload: message,
  };
}


